import { z } from "zod";
import { format } from "date-fns";

const optional = () => z.string().optional().or(z.literal(""));

export const cnLineSchema = z.object({
  id: z.string().optional(),
  material_id: z.string().min(1, "Material required"),
  material_grade_id: optional(),
  shape_size_id: optional(),
  description: optional(),
  qty: z.coerce.number().int().min(0),
  weight: z.coerce.number().min(0),
  uom_id: optional(),
  unit_rate: z.coerce.number().min(0),
  gst_slab: z.coerce.number().min(0).max(100),
});

export const creditNoteFormSchema = z
  .object({
    client_id: z.string().min(1, "Client is required"),
    invoice_id: optional(),
    issue_date: z.string().min(1),
    reason: optional(),
    bill_to_text: optional(),
    discount: z.coerce.number().min(0),
    adjustment: z.coerce.number(),
    notes: optional(),
    lines: z.array(cnLineSchema).min(1, "Add at least one line"),
  })
  .superRefine((values, ctx) => {
    values.lines.forEach((line, i) => {
      if (line.qty <= 0 && line.weight <= 0) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          path: ["lines", i, "weight"],
          message: "Enter qty or weight",
        });
      }
    });
  });

export type CnLineFormValues = z.infer<typeof cnLineSchema>;
export type CreditNoteFormValues = z.infer<typeof creditNoteFormSchema>;

export function emptyCnLine(): CnLineFormValues {
  return {
    material_id: "",
    material_grade_id: "",
    shape_size_id: "",
    description: "",
    qty: 0,
    weight: 0,
    uom_id: "",
    unit_rate: 0,
    gst_slab: 18,
  };
}

export const emptyCreditNoteForm: CreditNoteFormValues = {
  client_id: "",
  invoice_id: "",
  issue_date: format(new Date(), "yyyy-MM-dd"),
  reason: "",
  bill_to_text: "",
  discount: 0,
  adjustment: 0,
  notes: "",
  lines: [emptyCnLine()],
};
